import { defineComponent as _defineComponent } from 'vue'
import {computed, onBeforeMount, ref} from "vue";
import {useUserServiceStore} from "@/store/userService.store";
import KycTier from "@/components/kyc/KycTier.vue";
import { KycTierEnum} from "@/models/user/kyc";
import Dialog from "primevue/dialog";
import SynapsVerify from '@synaps-io/vue3-verify';


export default /*#__PURE__*/_defineComponent({
  __name: 'KycView',
  setup(__props, { expose: __expose }) {
  __expose();

onBeforeMount(() => {
  useUserServiceStore().getKycStatus().then(() => {
    tierInfoList.value = [
      {
      header: 'Level 1',
      description: 'Lorem ipsum lorem ipsum lorem lorem',
      steps: useUserServiceStore().getKycTierSteps(KycTierEnum.TIER_1),
      tier: 6182
      },
      {
        header: 'Level 2',
        description: 'Lorem ipsum lorem ipsum lorem lorem',
        steps: useUserServiceStore().getKycTierSteps(KycTierEnum.TIER_2),
        tier: 8399
      }];
  });

});
const selectedTierId = ref();
const modalVisible = ref<boolean>(false);
const sessionId = computed(() => {
  return useUserServiceStore().kycSessionId;
});


const tierInfoList = ref();
const onVerifyButton = (tier: number) => {
  selectedTierId.value = tier;
  modalVisible.value = true;
};

const __returned__ = { selectedTierId, modalVisible, sessionId, tierInfoList, onVerifyButton, KycTier, get Dialog() { return Dialog }, get SynapsVerify() { return SynapsVerify } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})